module.exports = __webpack_public_path__ + "static/media/EBE67835-54F9-46F2-896E-98F1BA4636F6.f85c382e.bin";